import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import SubMenu from "../../Header/Navbar/SubMenu";
import "../Navbar/Navbar.css";
import { NavLink, useLocation } from "react-router-dom"; 

const Index = ({ menuData }) => {
  const location = useLocation(); 
  const [menus, setActive] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const isActive = (href) => {
    return location.pathname === href; 
  };

  const handleToggle = () => {
    setActive(!menus);
    // Close all submenus when closing mobile menu
    if (menus) {
      setActiveSubmenu(null);
    }
  };

  const handleMenuClick = () => {
    setActive(false);
    setActiveSubmenu(null);
  };

  const handleSubmenuToggle = (index) => {
    setActiveSubmenu(activeSubmenu === index ? null : index);
  };

  return (
    <div className="navbar p-0 gap-3">
      
      <div className="col-12 float-start d-lg-flex justify-content-end gap-3 desktop-show">
        <a href="tel:9910520768">
          <div className="button-container-1 redColor flex-center d-flex">
            <span className="col-12 flaot-start lh-1">Enquire Now</span>
            <span className="col-12 flaot-start lh-1">+91 99105 20768</span>
          </div>
        </a>
      </div>
      
      <div className="col-12 float-start menuStrip">
        {/* Desktop Menu */}
        <ul className="d-lg-flex desktop-show">
          {menuData.map((menu, index) => (
            <li key={index} onClick={handleMenuClick}>
              {menu.link ? (
                <NavLink
                  to={menu.link}
                  className={isActive(menu.link) ? "active" : ""}
                >
                  {menu.name}
                </NavLink>
              ) : (
                menu.name
              )}
              {menu.submenus && (
                <SubMenu
                  submenus={menu.submenus}
                  showViewAllLink={menu.showViewAllLink}
                />
              )}
            </li>
          ))}
        </ul>

        {/* Mobile Hamburger Button */}
        <button
          onClick={handleToggle}
          className={menus ? "hamburger active" : "hamburger"}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={menus ? "menus active" : "menus"}>
        <div className="col-lg-11 col-12 subMenu flex-center justify-content-lg-end h-100">
          <ul className="text-white">
            {menuData.map((menu, index) => (
              <li key={index} className="mobile-show mobile-menu-item">
                {menu.submenus ? (
                  // Menu item with submenus
                  <div className="mobile-parent-menu">
                    <div 
                      className="mobile-menu-header"
                      onClick={() => handleSubmenuToggle(index)}
                    >
                      {menu.link ? (
                        <NavLink
                          to={menu.link}
                          className={isActive(menu.link) ? "active" : ""}
                          onClick={handleMenuClick}
                        >
                          {menu.name}
                        </NavLink>
                      ) : (
                        <span>{menu.name}</span>
                      )}
                      <span className={`submenu-toggle ${activeSubmenu === index ? 'active' : ''}`}>
                        &#9660;
                      </span>
                    </div>
                    
                    {/* Mobile Submenu */}
                    <div className={`mobile-submenu ${activeSubmenu === index ? 'active' : ''}`}>
                      {menu.submenus.map((submenu, subIndex) => (
                        <div key={subIndex} className="mobile-submenu-item">
                          {submenu.link ? (
                            <NavLink
                              to={submenu.link}
                              className={isActive(submenu.link) ? "active" : ""}
                              onClick={handleMenuClick}
                            >
                              {submenu.text}
                            </NavLink>
                          ) : (
                            <span>{submenu.text}</span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  // Regular menu item without submenus
                  menu.link ? (
                    <NavLink
                      to={menu.link}
                      className={isActive(menu.link) ? "active" : ""}
                      onClick={handleMenuClick}
                    >
                      {menu.name}
                    </NavLink>
                  ) : (
                    menu.name
                  )
                )}
              </li>
            ))}
            <li><NavLink to='/gallery' onClick={handleMenuClick}>Gallery</NavLink></li>
            <li><NavLink to='/gallery' onClick={handleMenuClick}>Request A Quote</NavLink></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Index;